import { render } from "./filterAccordian.vue?vue&type=template&id=2b9d86c4&scoped=true"
import script from "./filterAccordian.vue?vue&type=script&lang=js"
export * from "./filterAccordian.vue?vue&type=script&lang=js"

import "./filterAccordian.vue?vue&type=style&index=0&id=2b9d86c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9d86c4"]])

export default __exports__